import { render, staticRenderFns } from "./SalesChannel.vue?vue&type=template&id=0a14683c"
import script from "./SalesChannel.vue?vue&type=script&lang=js"
export * from "./SalesChannel.vue?vue&type=script&lang=js"
import style0 from "./SalesChannel.vue?vue&type=style&index=0&id=0a14683c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports